import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AnimatedLoginBackground } from '@/components/layout/AnimatedLoginBackground';
import { LoginForm } from './LoginForm';
import { SignupForm } from './SignupForm';

export const Login = () => {
    // Prevent scrolling on the entire page while on the Login route
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, []);

    const location = useLocation();
    const navigate = useNavigate();
    
    // Check if the URL is /cadastro or /signup to open the signup form
    const isSignUpOpen = location.pathname === '/cadastro' || location.pathname === '/signup';

    // Catch OAuth errors that may have slipped to the login page
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const hashParams = new URLSearchParams(location.hash.substring(1));
        const errorParam = params.get('error') || hashParams.get('error');
        const errorDescription = params.get('error_description') || hashParams.get('error_description');

        if (errorParam) {
            // Limpa a URL para não mostrar o erro toda vez que atualizar a página
            navigate(location.pathname + location.search, { replace: true });
            
            if (errorParam === 'access_denied') {
                toast.error('Você cancelou o login. Tente novamente quando quiser.', { duration: 6000 });
            } else {
                toast.error(errorDescription || 'Falha na conexão com o provedor. Tente novamente.', { duration: 6000 });
            }
        }
    }, [location.search, location.hash, location.pathname, navigate]);

    const toggleView = () => {
        const search = location.search || '';
        if (isSignUpOpen) {
            navigate(`/login${search}`);
        } else {
            navigate(`/cadastro${search}`);
        }
    };
    
    return (
        <AnimatedLoginBackground>
            <div className="flex flex-col items-center justify-center w-full h-full p-4">
                
                {/* Wrap the forms in a parent with `overflow-hidden` so that the slider effect works properly */}
                {/* Added entry animation to buy time for Turnstile captcha verfication in background */}
                <div className="w-full max-w-[420px] max-h-full bg-white/95 backdrop-blur-sm rounded-[1.5rem] shadow-2xl border border-slate-100/80 overflow-y-auto overflow-x-hidden relative transition-all ease-out animate-form-fade-in">
                    
                    {/* SLIDER CONTAINER */}
                    {/* Width is 200% so that each child (w-1/2) takes exactly 100% of the parent container */}
                    <div className={`flex items-stretch transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] w-[200%] h-full ${isSignUpOpen ? '-translate-x-1/2' : 'translate-x-0'}`}>
                        
                        <LoginForm onToggleView={toggleView} isActive={!isSignUpOpen} />
                        <SignupForm onToggleView={toggleView} isActive={isSignUpOpen} />

                    </div>
                </div>

            </div>
        </AnimatedLoginBackground>
    );
};


